export default "__VITE_ASSET__DbI_$xSc__"